import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Dispatch, AnyAction } from 'redux';
import { CustomizationEntry, IAppState, WebchatOptions } from "./druid/./druid/Redux/reduxState";
import { genericSingleAction, actionTypes } from "./druid/./druid/Redux/actions";
import { UISelectorType } from "./druid/./druid/utilities/types";
import { DefaultSelector } from "/druid/defaultSelector";
import { BooleanSelector } from "/druid/booleanSelector";
import { IntegerSelector } from "/druid/integerSelector";
import { PercentageSelector } from "/druid/percentageSelector";
import { ColorSelector } from "/druid/colorSelector";
import { RgbaSelector } from '/druid/rgbaSelector'

import { mergeStyles } from "@fluentui/react";
import { DropDownSelector } from "/druid/dropDownSelector";
import { ContainerName } from "./druid/./druid/Redux/reducers/AppReducer";
import { DEFAULT_UNDEFINED_RGBA } from "./druid/constants/defaultStyleOptions";
import { ReactSelector } from "/druid/reactSelector";
import { LocalizationSelector } from "/druid/localizationSelector";
import WebChatOptionsSearch from "/druid/WebChatOptionsSearch";


const UI_selector = mergeStyles(
    {
        fontSize: '15px',
        fontWeight: '400',
        paddingBottom: 15
    }
);

interface CustomizationEntrySelectorProps {
    entry: CustomizationEntry;
    value: any;
    onChange: (styleElementName: string, value: any, containerName?: ContainerName) => void;
    getStyleOptionValue: (key: any, containerName?: ContainerName) => any;
}

export const CustomizationEntrySelector = (props: CustomizationEntrySelectorProps) => {
    const { entry, value, onChange, } = props;
    const { displayName, id } = entry;

    const onChangeWithContainerName = (styleElementName: string, value: any) => {
        props.onChange(styleElementName, value, entry.containerName);
    }

    const renderSelector = (type: UISelectorType) => {
        switch (type) {
            case UISelectorType.booleanSelector:
                return <BooleanSelector id={id} onChange={onChangeWithContainerName} value={value} />
            case UISelectorType.integerSelector:
                return <IntegerSelector id={id} onChange={onChangeWithContainerName} value={value} />
            case UISelectorType.percentageSelector:
                return <PercentageSelector id={id} onChange={onChangeWithContainerName} value={value} />
            case UISelectorType.colorSelector:
                return <ColorSelector id={id} onChange={onChangeWithContainerName} value={value} getStyleOptionValue={props.getStyleOptionValue} />
            case UISelectorType.dropDownSelector:
                return <DropDownSelector id={id} onChange={onChangeWithContainerName} value={value} />
            case UISelectorType.rgbaSelector:
                return <RgbaSelector id={id} onChange={onChangeWithContainerName} value={value || DEFAULT_UNDEFINED_RGBA} />
            case UISelectorType.reactSelector:
                return <ReactSelector id={id} onChange={onChangeWithContainerName} value={value || ""} defaultValue={entry.defaultValue} />
            case UISelectorType.localizationSelector:
                return <LocalizationSelector 
                    id={id} onChange={onChangeWithContainerName} 
                    value={value || ""} defaultValue={entry.defaultValue} 
                    languages={props.getStyleOptionValue("languages", "root")}
                    />
            case UISelectorType.searchSelector:
                return <WebChatOptionsSearch />
            case UISelectorType.defaultSelector:
            default:
                return <DefaultSelector multiline={entry.multiline} id={id} onChange={onChangeWithContainerName} value={value} />
        }
    }

    return (
        <div className={UI_selector}>
            {displayName !== "Search" && displayName} {displayName !== "Search" && <strong> ({id}) </strong>} 

            {renderSelector(entry.uiSelectorType)}
        </div>
    );
}
